module.exports = __webpack_public_path__ + "img/avatar.fd3593fa.png";